import { render } from "./ForecastCreate.vue?vue&type=template&id=bf44c180"
import script from "./ForecastCreate.vue?vue&type=script&lang=js"
export * from "./ForecastCreate.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__